import Text12 from '@sdk/components/ui/typography/Text12';
import { pgettext } from '@sdk/lang/gettext';
import Href from '@sdk/components/ui/Href';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  Container,
  TextContainer,
} from '@web/labor/LaborInformationBox/laborInformationBox.styles';

type Props = {
  summary: { allShifts: number };
  openAddShiftModal: () => void;
};
const ShiftsSummaryInformationBox = ({ summary, openAddShiftModal }: Props) => {
  if (summary.allShifts) {
    // Hint is present until at least one shift has been created.
    return null;
  }

  return (
    <Container pLeft={20} pRight={20} pTop={10} pBottom={10}>
      <TextContainer>
        <Href onClick={openAddShiftModal} fontSize={12} themeColor={ThemeColorType.primary}>
          {pgettext('Add shifts to your schedule. ', 'Add shifts')}
        </Href>
        <Text12 themeColor={ThemeColorType.gray}>
          &nbsp;{pgettext('Add shifts to your schedule. ', 'to your schedule.')}
        </Text12>
      </TextContainer>
    </Container>
  );
};

export default ShiftsSummaryInformationBox;
